module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "structure-tt"
  }, [_vm._v("Postcards to the Universe")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("Harness the Universe’s Power and Manifest Your Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("Melisa Caprio"), _c('br', {
    staticClass: "calibre2"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/2.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Coral Gables")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "charoverride3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662565d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ebook_split_003.vue
// module id = 63
// module chunks = 0